import resolveLink from './resolveLink';
import resolveRTC from './resolveRTC';

const resolveSimpleContent = ({
  rawVal,
  page,
  pageModels,
}: PropsWithCMSProps<SimpleContentProps>) => {
  const content = rawVal && page?.getContent(rawVal);
  const { detailContent, secondaryCTA, primaryCTA, heading } =
    content?.getData<SimpleContentDocType>() || {};
  return {
    detailContent: resolveRTC({ rawVal: detailContent }),
    secondaryCTA: secondaryCTA && resolveLink({ rawVal: secondaryCTA, page, pageModels }),
    primaryCTA: primaryCTA && resolveLink({ rawVal: primaryCTA, page, pageModels }),
    heading,
  } as SimpleContentType;
};

export default resolveSimpleContent;
